import { Box, BoxProps, GridItem, Td } from "@chakra-ui/react";

interface TableCellProps extends BoxProps {
  selected?: boolean;
}

export function TableCell({
  children,
  selected = false,
  title: restTitle,
  ...rest
}: TableCellProps) {
  const childrenIsStringOrNumber = typeof children === "string" || typeof children === "number";
  const title = restTitle ?? (childrenIsStringOrNumber ? children + "" : undefined);
  return (
    <GridItem
      as={Td}
      display="flex"
      alignItems="center"
      overflow="hidden"
      textOverflow="ellipsis"
      whiteSpace="nowrap"
      verticalAlign="middle"
      color="brand.deep_sea"
      fontWeight={400}
      textStyle="sm"
      p={2}
      py={3}
      borderBottomWidth={0}
      title={title}
      {...rest}
      _first={{ pl: 0 }}
      _last={{ pr: 0 }}
      {...(rest.onClick ? { cursor: "pointer", _hover: { textDecor: "underline" } } : {})}
    >
      {childrenIsStringOrNumber ? (
        <Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
          {children}
        </Box>
      ) : (
        children
      )}
    </GridItem>
  );
}
